import { z } from 'zod';

export const appVersionSchema = z.object({
  id: z.coerce.number(),
  version: z.string(),
  releaseDate: z.string(),
  isCurrent: z.boolean(),
  message: z.string().nullable(),
  downloadLink: z.string().nullable(),
});

export const appVersionListSchema = z.array(appVersionSchema);

export type AppVersion = z.infer<typeof appVersionSchema>;

export const appVersionMemberSchema = z.object({
  userId: z.coerce.number(),
  name: z.string(),
  hrEmpId: z.string().nullable(),
  mobile: z.string().nullable(),
  divisionName: z.string().nullable(),
  districtName: z.string().nullable(),
  thanaName: z.string().nullable(),
  appVersion: z.string().nullable(),
  lastLoginTime: z.coerce.date().nullable(),
});

export const appVersionAreaManagerSchema = z.object({
  userId: z.coerce.number().nullable(),
  name: z.string().nullable(),
  hrEmpId: z.string().nullable(),
  mobile: z.string().nullable(),
  memberCount: z.number(),
  members: z.array(appVersionMemberSchema),
});

export const appVersionDepartmentSchema = z.object({
  departmentId: z.coerce.number().nullable(),
  departmentName: z.string(),
  areaManagers: z.array(appVersionAreaManagerSchema),
});

export const appVersionCheckReportSchema = z.object({
  departments: z.array(appVersionDepartmentSchema),
  totalDepartments: z.number(),
  totalAreaManagers: z.number(),
  totalMembers: z.number(),
});

export type AppVersionMember = z.infer<typeof appVersionMemberSchema>;
export type AppVersionAreaManager = z.infer<typeof appVersionAreaManagerSchema>;
export type AppVersionDepartment = z.infer<typeof appVersionDepartmentSchema>;
export type AppVersionCheckReport = z.infer<typeof appVersionCheckReportSchema>;

export const appVersionCheckSearchSchema = z.object({
  appVersion: z.string().optional(),
  companyId: z.coerce.number().optional(),
  departmentId: z.coerce.number().optional(),
  reportingMemberId: z.coerce.number().optional(),
  divisionId: z.coerce.number().optional(),
  districtId: z.coerce.number().optional(),
  thanaId: z.coerce.number().optional(),
});

export type AppVersionCheckSearch = z.infer<typeof appVersionCheckSearchSchema>;
export type AppVersionCheckParams = AppVersionCheckSearch;
export type AppVersionCheckFilterValues = Record<string, string>;
